import React from 'react';
import HeroSection from '../components/HeroSection';
import GreatestCompanies from '../components/GreatestCompanies';
import GrowYourBusiness from '../components/GrowYourBusiness';
import ProductsSection from '../components/ProductsSection';
import WeAreAll from '../components/WeAreAll';
import TopServices from '../components/TopServices';
import UnleashPotential from '../components/UnleashPotential';
import WhiteMenuSection from '../components/WhiteMenuSection';
import Recommendations from '../components/Recommendations';
import Partners from '../components/Partners';

function Home() {
  return (
    <>
      <div className="App-main">
        <HeroSection />
        <GreatestCompanies />
      </div>

      <div className='App-max-width grow-your-buisness-archor'>
        <GrowYourBusiness />
      </div>

      <div className='App-main'>
        <ProductsSection />
        <WeAreAll />
        <TopServices />
      </div>
      <div className='App-max-width'>
        <WhiteMenuSection />
      </div>
      <div className='App-main'>
        <UnleashPotential />
        <Partners />
      </div>
    </>
  );
}

export default Home;
